// extracted by mini-css-extract-plugin
export default {"nomatchSection":"style_nomatchSection__itMG2","noMatch":"style_noMatch__zB5KL","sectionRow":"style_sectionRow__wpmJr"};